import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AwardInformationEntryComponent } from './award/award-information-entry/award-information-entry.component';
import { DonorListComponent } from './Donor/donor-list/donor-list.component';
import { DonorInformationEntryComponent } from './Donor/donor-information-entry/donor-information-entry.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './auth-guard.service';
import { MsalGuard } from '@azure/msal-angular';
import { CanDeactivateGuard } from './can-deactivate/can-deactivate.guard';
import { DataMigrationComponent } from './award/data-migratrion/data-migration/data-migration.component';
import { ReportComponent } from './report/report/report.component';
import { AuthorizedErrorComponent } from './common/components/authorized-error/authorized-error/authorized-error.component';

/**
 * MSAL Angular can protect routes in your application
 * using MsalGuard. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#secure-the-routes-in-your-application
 */
const routes: Routes = [

  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'authorized-error',
    component: AuthorizedErrorComponent,
  },
  // { path: 'users', component: PageNotFoundComponent, children: [{ path: ':id/:name', component: PageNotFoundComponent }] },
  {
    path: 'donor-list',
    component: DonorListComponent,
  },
  {
    path: 'award-information-entry',
    component: AwardInformationEntryComponent,
    canDeactivate: [CanDeactivateGuard] // for dirty check
  },
  {
    path: 'donor-information-entry',
    component: DonorInformationEntryComponent,
    canDeactivate: [CanDeactivateGuard] // for dirty check
  },
  {
    path: 'data-migration',
    component: DataMigrationComponent,
  },
  {
    path: 'not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'report',
    component: ReportComponent
  },
  {
    // Needed for hash routing
    path: 'error',
    redirectTo: 'dashboard'
  },
  {
    // Needed for hash routing
    path: 'state',
    redirectTo: 'dashboard'
  },
  {
    // Needed for hash routing
    path: 'code',
    redirectTo: 'dashboard'
  },
  {
    path: '**',
    redirectTo: '/not-found',
    pathMatch: 'full'
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    // Don't perform initial navigation in iframes
    initialNavigation: !isIframe ? 'enabled' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }